<template>
  <div class="wrapper">
    <el-form
      :inline="true"
      size="small"
      :model="searchParams"
      class="search-form"
    >
      <el-form-item label="备注">
        <el-input
          v-model="searchParams.description"
          placeholder="请输入备注"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          v-model="searchParams.status"
          :clearable="true"
          placeholder="请选择状态"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <header>
      <h3>json文件列表</h3>
      <el-button
        size="small"
        type="primary"
        class="add-btn"
        @click="addJsonFile()"
        >新增json文件</el-button
      >
    </header>
    <el-table
      v-loading="loading"
      :data="tableData"
      border
      class="json-file-table"
    >
      <el-table-column prop="_id" label="ID" width="220" />
      <el-table-column prop="createBy" label="创建者" width="90" />
      <el-table-column prop="status" label="状态" width="120">
        <template slot-scope="scope">
          {{ scope.row.status | status }}
        </template>
      </el-table-column>
      <el-table-column prop="cdn" label="cdn" min-width="300">
        <template slot-scope="scope">
          <a
            v-if="scope.row.cdn"
            :href="scope.row.cdn.url"
            :title="scope.row.cdn.url"
            target="_blank"
            >{{ scope.row.cdn.url }}</a
          >
          <span v-else> - </span>
        </template>
      </el-table-column>
      <el-table-column prop="description" min-width="200" label="备注" />
      <el-table-column prop="createAt" width="166" label="创建时间">
        <template slot-scope="time">
          {{ time.row.meta.createAt | formatDate }}
        </template>
      </el-table-column>
      <!--  <el-table-column prop="updateAt" label="更新时间">
        <template slot-scope="time">
          {{ time.row.meta.updateAt | formatDate }}
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <div class="options">
            <el-button
              v-if="scope.row.status != 1"
              @click="changeStatus(scope.row)"
              type="text"
              size="small"
            >
              发布
            </el-button>
            <el-button type="text" size="small" @click="editFile(scope.row)"
              >编辑
            </el-button>
            <el-button
              @click="editFileDescription(scope.row)"
              type="text"
              size="small"
            >
              {{ scope.row.description ? "编辑备注" : "添加备注" }}
            </el-button>
            <el-button @click="deleteFile(scope.row)" type="text" size="small"
              >删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagation" v-show="tableData.length > 0">
      <el-pagination
        layout="total, prev, pager, next"
        :total="page.totalCount"
        :page-size="page.pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <option-dialog
      title="请输入json文件描述"
      :visible="jsonFile.visible"
      @close="handleClose"
      @submit="handleSubmit"
    >
      <div>
        <el-input v-model="jsonFile.description"></el-input>
      </div>
    </option-dialog>
  </div>
</template>

<script>
import { formatDate } from "@/js/common/utils";
import OptionDialog from "./option-dialog.vue";
const STATUS = ["未发布", "已发布", "已更新未发布"];
export default {
  name: "JsonFileList",
  data() {
    return {
      options: [
        {
          label: "已更新未发布",
          value: 2,
        },
        {
          label: "已发布",
          value: 1,
        },
        {
          label: "未发布",
          value: 0,
        },
      ],
      searchParams: {
        description: "",
        status: "",
      },
      page: {
        current: 1,
        totalCount: 0,
        pageSize: 10,
      },
      jsonFile: {
        visible: false,
        description: "",
      },
      tableData: [],
      loading: false,
    };
  },
  components: {
    OptionDialog,
  },
  filters: {
    formatDate,
    status(value) {
      return STATUS[value] || "";
    },
  },
  mounted() {
    const { current: page, pageSize } = this.page;
    const query = { page, pageSize };
    this.fetchJsonFileList(query);
  },
  methods: {
    addJsonFile() {
      this.$router.push("/json/edit");
    },
    handleSizeChange() {},
    handleCurrentChange(page) {
      this.page.current = page;
      const { pageSize } = this.page;
      const query = { page, pageSize, ...this.searchParams };
      this.fetchJsonFileList(query);
    },
    onSearch() {
      this.fetchJsonFileList(this.searchParams);
    },
    flushJsonFileList() {
      const { pageSize, current: page } = this.page;
      const query = { page, pageSize, ...this.searchParams };
      this.fetchJsonFileList(query);
    },
    fetchJsonFileList(params = {}) {
      this.loading = true;
      lib.tmsapi.get({
        api: "api/test/json",
        data: params,
        success: (res) => {
          if (res.data) {
            this.loading = false;
            this.tableData = res.data.list || [];
            this.page.totalCount = res.data.total;
            this.page.current = res.data.current;
          }
        },
      });
    },
    deleteFile(row) {
      this.$confirm("你是否确认要删除该文件，删除后无法恢复！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return new Promise((resolve, reject) => {
            lib.tmsapi.post({
              api: `api/test/json/delete/${row._id}`,
              success: (res) => resolve(res),
            });
          });
        })
        .then((res) => {
          return this.$message({ type: "success", message: "已成功删除文件" });
        })
        .then(() => this.fetchJsonFileList())
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    editFile(row) {
      console.log(row);
      this.$router.push(`/json/edit/${row._id}`);
    },
    changeStatus(row) {
      this.$confirm("你确定要发布这个json文件吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          lib.tmsapi.post({
            api: `api/test/json/publish/${row._id}`,
            success: (res) => {
              this.$message({
                type: "success",
                message: "发布成功",
              });
              this.fetchJsonFileList();
            },
            error: (e) => {
              this.$message({
                type: "error",
                message: "发布失败！",
              });
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消发布",
          });
        });
    },
    handleClose() {
      this.jsonFile.visible = false;
    },
    handleSubmit() {
      const data = {
        description: this.jsonFile.description,
      };
      lib.tmsapi.post({
        api: `api/test/json/${this.jsonFile.id}`,
        data,
        success: (res) => {
          console.log(res);
          this.$message({
            type: "success",
            message: "描述修改成功！",
          });
          this.flushJsonFileList();
          this.jsonFile.visible = false;
          this.jsonFile.id = "";
          this.jsonFile.description = "";
        },
        error: (err) => {
          this.$message({
            type: "error",
            message: "描述修改失败！",
          });
        },
      });
    },
    editFileDescription(row) {
      this.jsonFile.id = row._id;
      this.jsonFile.description = row.description;
      this.jsonFile.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 20px;
  background-color: #fff;
  margin: 20px;
  .search-form {
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }
  header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 16px 8px;
    h3 {
      color: #606266;
    }
  }
  .json-file-table {
    .options {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>
